import { styled } from "simplydo/react/styled";

import { useCurrentUser } from "utils/currentUser";

import MessageTray from "components/lib/Messaging/MessageTray";

const MessagesContainer = styled.div`
  background-color: #fff;
  padding: 1rem;
`;

const MobileMessageWidget = () => {
  const user = useCurrentUser();
  if (!user) return null;
  return (
    <MessagesContainer>
      <MessageTray isMobile />
    </MessagesContainer>
  );
};

export default MobileMessageWidget;
